import Signal from 'libs/signals';

const stateProgramsSignal = Signal({
  loading: false,
  fundingPrograms: [],
  selectedFundingProgram: null,
});

export default stateProgramsSignal;
